import { B2B_CART } from '../actions';

export default function (state = {}, action) {
  switch (action.type) {
    case B2B_CART:
      return action.payload;
    default:
      return state;
  }
}
